import React from 'react';
import { makeStyles, Paper, Button, CircularProgress } from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import styles from './styles';
const useStyles = makeStyles(styles);

function StickMessage(props) {
  const classes = useStyles();
  const { type, title, subtitle, hasButton, onClick, loading } = props;

  return (
    <Paper>
      <div className={classes.container}>
        <div className={classes.boxIcon}>
          {(!type || type !== 'alert') && <InfoOutlinedIcon className={classes.icon} />}
          {type && type === 'alert' && <ReportProblemOutlinedIcon className={classes.icon} />}
        </div>
        <div className={classes.boxTitle}>
          <h4 className={classes.title}>{title}</h4>
          <h5 className={classes.subtitle}>{subtitle}</h5>
        </div>
      </div>
      {hasButton && (
        <div className={classes.boxButton}>
          {loading && (
            <div className={classes.centerProgress}>
              <CircularProgress size={12} />
            </div>
          )}
          {!loading && (
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              disableElevation
              onClick={() => onClick()}
            >
              Confira
            </Button>
          )}
        </div>
      )}
    </Paper>
  );
}

export default StickMessage;
